import "./utcDates";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { installBaaWatcher } from "./components/baa/baaWatcher";

installBaaWatcher();

// Unregister any stale service workers inline — no external file needed
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => reg.unregister());
  });
}

// Report browser crashes to the app monitor (throttled, best-effort)
(() => {
  let sent = 0;
  const report = (message, source, stack) => {
    if (sent >= 5 || !message) return;
    sent += 1;
    try {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/monitor/client-error`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: String(message).slice(0, 500), source: String(source || ''), url: window.location.href, stack: String(stack || '').slice(0, 1500) }),
        keepalive: true,
      }).catch(() => {});
    } catch (e) { /* ignore */ }
  };
  window.addEventListener('error', (e) => report(e.message, e.filename, e.error?.stack));
  window.addEventListener('unhandledrejection', (e) => report(e.reason?.message || String(e.reason), 'promise', e.reason?.stack));
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
